export default function HeatByHeatBestSegment(){
  
  const error = () => console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
  
  if($('#hbh-best-segment').length){
    const eventUrl = window.location.pathname.split('/')
    const eventSanction = eventUrl[2] 
    const eventID = eventUrl[4]
    const eventName = eventUrl[5].replace(/-/g, ' ');
    const loaded = (target) => $(target).addClass('loaded')

    $(`#session-name`).html(eventName)

    $.ajax( {
      url: `https://data-aws.amaproracing.com/api/reporting/bestsegments/${eventID}`,
      method: 'GET',
      dataType: 'json',
      error: () => error(),
      success: data => {
        const results = data[0].BestSegments
        const container = $('#bs-container')
        let content = ``
        let counter = 1
        for(let result of results){
          content += `<div class="bs-table-col">`
          content += `  <div class="bs-table-row title">Segment ${result.ShortName}</div>`
          content += `  <div class="bs-table-row heading">`
          content += `    <div class="bs-table-inner-col">Pos</div>`
          content += `    <div class="bs-table-inner-col">#</div>`
          content += `    <div class="bs-table-inner-col">Name</div>`
          content += `    <div class="bs-table-inner-col">Best Time</div>`
          content += `    <div class="bs-table-inner-col">Lap</div>`
          content += `  </div>`
          content += `  <div class="content">`
          for(let item of result.SectionResults){
            content += `    <div class="bs-table-row body">`
            content += `      <div class="bs-table-inner-col">${counter}</div>`
            content += `      <div class="bs-table-inner-col">${item.No}</div>`
            content += `      <div class="bs-table-inner-col">${item.FullName}</div>`
            content += `      <div class="bs-table-inner-col">${item.STimeText}</div>`
            content += `      <div class="bs-table-inner-col">${item.Lap}</div>`
            content += `    </div>`
            counter ++
          }
          content += `  </div>`
          content += `  <button class="bs-view-all btn btn-purple btn-small mobile">view more</button>`
          content += `  `
          content += `</div>`
        }
        container.html(content)
        loaded(`#hbh-best-segment`)
        $('.bs-view-all').click(function(){
          if($(this).html() === 'view more'){
            $(this).html('view less')
          }else{
            $(this).html('view more')
          }
          $(this).parent().toggleClass('active')
        })
      }
    });

  }


}